import LargeComponent from './NavDropdown'
import SmallComponent from './SmallNavDropdown'
import WithResponsive from '../../hoc/WithResponsive'

export default WithResponsive(LargeComponent, SmallComponent)
